import { MultiplierAnimationConfig } from '@Animation/types'
import { preLoadAssets } from './asset-preloader'
import { KenoSnakesMultiplierAnimation } from './keno-snakes-multiplier-animation'

export const KENO_SNAKES_MULTIPLIER_CONFIG: MultiplierAnimationConfig = {
  assetPreloader: preLoadAssets,
  revealAnimation: KenoSnakesMultiplierAnimation,
}
